import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useNavigate } from 'react-router'
import { Element } from '../../../../../common/html/element'
import { PopupAction } from '../../../../../common/popup/PopupAction'
import { COMPONENTS } from '../../../../../routers/constants'
import { changeFilter } from '../../../savedCriteria/store/slice'
import { getSavedCriteria } from '../../../savedCriteria/store/thunk'
import {
  changeSaveCriteriaPopup,
  selectSaveCriteriaPopup,
} from '../../store/slice'

export const OpenRecentSavedPopup = ({
  isShow,
  setIsShow,
  savedCriteriaId,
}) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { lastPathname } = useSelector(selectSaveCriteriaPopup)

  const handleClosePopup = () => {
    if (lastPathname) {
      dispatch(changeSaveCriteriaPopup({ lastPathname: null }))
    }
    setIsShow(false)
  }

  const handleDontOpenRecentSaved = () => {
    const navigatePath = lastPathname
    handleClosePopup()
    if (navigatePath) navigate(navigatePath)
  }

  const handleOpenRecentSaved = () => {
    handleClosePopup()
    dispatch(
      changeFilter({
        keyword: '',
        from: null,
        to: null,
        sortBy: null,
        sortDirection: null,
        page: 1,
      }),
    )
    dispatch(getSavedCriteria({ Id: savedCriteriaId }))
    navigate(COMPONENTS.screening.components.savedCriteria.route)
  }

  return (
    <PopupAction
      isShow={isShow}
      title="screening.CONFIRMATION"
      btnCancel={{
        label: 'screening.YES',
        isI18n: true,
        event: handleOpenRecentSaved,
      }}
      btnSubmit={{
        label: 'screening.NO',
        isI18n: true,
        event: handleDontOpenRecentSaved,
      }}
      handleClose={handleClosePopup}
    >
      <Element className="textCenter pb1">
        <Element style={{ color: '#3A414B' }}>
          <Translate value="screening.OPEN_RECENT_SAVED_MESS" dangerousHTML />
        </Element>
      </Element>
    </PopupAction>
  )
}
